<template>
    <div class="card">
        <div class="container-fluid p-3">
          <b-row>
            <div class="col-xl-6 ml-auto mr-auto">
              <b-card no-body>
                <b-card-header v-if="manifestId">
                  <div class="d-flex justify-content-between align-items-start">
                    <div class="col-10">
                      <h2> {{ manifestName }} </h2>
                    </div>
                    <div class="col-2 right-menu-buttons">
                      <b-button v-b-modal.create-reports-modal variant="outline-primary" class="mx-2 img-icon img-icon-document-copy" size="sm"></b-button>
                    
                      <add-manifest-to-cart :manifestId="manifestId"></add-manifest-to-cart>
                    </div>
                  </div>
                  <div>
                    <div>
                      <small class="text-muted">{{ manifestDate | moment("from") }}</small><br>
                      <div><small>{{ manifestDescription }}</small></div>
                    </div>

                    <div class="mt-auto"/>
                  </div>
                </b-card-header>
                <b-list-group flush class="entity-list-group">
                  <b-list-group-item v-for="entity in entitiesList" :key="entity.checksum" class="m-0 p-0">
                    <entity-list-group-item :entity="entity" :hideCart="true"></entity-list-group-item>
                  </b-list-group-item>
                </b-list-group>
                <b-card-footer>
                  <b-form-invalid-feedback :state="!errorMessage" class="text-center">
                      {{errorMessage}}
                  </b-form-invalid-feedback>
                </b-card-footer>
              </b-card>
            </div>
          </b-row>
          <b-modal
            id="create-reports-modal"
            ref="create-reports-modal" 
            title="Create Reports"
            centered
            button-size="sm"
            header-class="dflex align-items-center"
            header-bg-variant="success"
            body-bg-variant="secondary"
            footer-bg-variant="secondary"
            @show="reset"
            @hide="reset"
            hide-footer
        >
            <div>
              <b-form-group>
                  <label for="reportType">Select Format</label>
                  <b-form-checkbox v-model="pdf">pdf</b-form-checkbox>
                  <b-form-checkbox v-model="txt">txt</b-form-checkbox>
                  <b-form-checkbox v-model="csv">csv</b-form-checkbox>
              </b-form-group>
            </div>
            <div class="modal-footer">
                <b-button variant="outline-warning" size="sm" @click="hideModal">Cancel</b-button>
                <b-button variant="outline-primary" size="sm" @click="createReport">Create Report</b-button>
            </div>
          </b-modal>
        </div>
    </div>
</template>

<script>

import { ManifestGetSession } from '#/services/manifests/get';
import EntityListGroupItem from '#/ui/Components/Entities/EntityListGroupItem.vue';
import { EntityId } from '#/protobuf/general_pb';
import AddManifestToCart from '#/ui/Components/Manifest/AddManifestToCart.vue';
import { CreateReportRequest } from '#/protobuf/service_ingest_pb';

export default {
  components: {
    EntityListGroupItem,
    AddManifestToCart,
  },
  data() {
    const { manifestId } = this.$route.params;
    return {
      session: new ManifestGetSession(manifestId),
      pdf: false,
      txt: false,
      csv: false,
    };
  },
  created() {
    return this.session.load();
  },
  computed: {
    errorMessage() {
      return this.session.error;
    },
    manifest() {
      return this.session.manifest;
    },
    entitiesList() {
      if (this.session.manifest) {
        const entityList = this.session.manifest.getEntitiesList();
        const items = entityList.concat(this.jobsList);
        const newItems = [];
        for (let index = 0; index < items.length; index++) {
          const element = items[index].toObject();
          if (element.checksum) {
            const entityId = new EntityId();
            entityId.setSize(element.size);
            entityId.setChecksum(element.checksum);
            element.id = entityId.toString();
            element.itemType = 'entity';
          } else {
            element.id = element.jobId.toString();
            element.itemType = 'job';
          }
          newItems.push(element);
        }
        return newItems;
      }
      return [];
    },
    manifestName() {
      if (this.manifest) {
        return this.manifest.getManifestName();
      }
      return '';
    },
    manifestDescription() {
      if (this.manifest) {
        return this.manifest.getManifestDescription();
      }
      return '';
    },
    manifestDate() {
      if (this.manifest) {
        return this.manifest.getDateCreated();
      }
      return '';
    },
    manifestId() {
      if (this.manifest) {
        return this.manifest.getManifestId();
      }
      return '';
    },
    jobsList() {
      if (this.session.manifest) {
        return this.session.manifest.getJobsList();
      }
      return [];
    },
    manifestIds() {
      if (this.session.manifest) {
        return this.session.manifest.getJobsList().concat(this.session.manifest.getEntitiesList()).map((item) => item.toObject());
      }
      return [];
    },
    uniqueIds() {
      return this.manifestIds.map((item) => {
        if (item.checksum) {
          const entityId = new EntityId();
          entityId.setSize(item.size);
          entityId.setChecksum(item.checksum);
          return entityId.toString();
        }
        return item.jobId.toString();
      });
    },
    ids() {
      return this.$store.getters['datacart/cartIds'];
    },
    cartCheck() {
      return this.uniqueIds.filter((item) => this.ids.includes(item)).length === this.uniqueIds.length;
    },
  },
  methods: {
    addManifestToCart() {
      const items = this.entitiesList;
      for (let i = 0; i < items.length; i += 1) {
        this.$store.dispatch('datacart/addToCart', items[i]);
      }
    },
    removeManifestToCart() {
      for (let i = 0; i < this.uniqueIds.length; i += 1) {
        this.$store.dispatch('datacart/removeFromCart', { id: this.uniqueIds[i] });
      }
    },
    reset() {
      console.log('Reset modal');
    },
    createReport() {
      console.log('create report');
      const request = new CreateReportRequest();
      request.setManifestId(this.manifestId);
      if (this.pdf) request.setPdf(2);
      if (this.txt) request.setTxt(3);
      if (this.csv) request.setCsv(4);

      console.log(request);

      this.$store.dispatch('datacart/createReport', request).then((response) => {
        const res = response.toObject();
        this.$router.push({ path: `/live/${res.jobId}`, project: this.$route.query.project });
      }).catch((error) => {
        console.log('promise rejected creating report:', error);
        this.isSubmitted = false;
        this.$bvToast.toast(error, {
          title: 'Error in creating manifest',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        });
      }).finally(() => {
        this.isSubmitted = false;
      });
    },
    hideModal() {
      this.$refs['create-reports-modal'].hide()
    }
  },
};
</script>

<style lang="scss">
.vue-tags-input {
  max-width: 100% !important;
}
.right-menu-buttons {
  display: flex;
}
</style>
